import { useEffect, useRef } from "react";

import { Provider, useBookingFlowEvents } from "~/services";
import { useDebounce } from "~/shared/hooks/useDebounce";
import { formatDateKey } from "~/shared/utils";

type UseTrackSlotDateViewsParams = {
  date: Date;
  providers: Provider[];
  enabled: boolean;
};

export const useTrackSlotDateViews = ({
  date,
  providers,
  enabled,
}: UseTrackSlotDateViewsParams) => {
  const { trackSlotDateView } = useBookingFlowEvents();
  const trackSlotDateViewRef = useRef(trackSlotDateView);
  trackSlotDateViewRef.current = trackSlotDateView;
  const sentSlotDateViewsRef = useRef<Set<string>>(new Set());

  const debouncedDate = useDebounce(date);

  useEffect(() => {
    if (!enabled || !providers.length) return;

    const dateKey = formatDateKey(debouncedDate);
    if (sentSlotDateViewsRef.current.has(dateKey)) return;

    trackSlotDateViewRef.current(debouncedDate, providers, () =>
      sentSlotDateViewsRef.current.add(dateKey),
    );
  }, [debouncedDate, providers, enabled]);
};
